import BackendService from "../consumer/common/BackendService";
import StvLogLevel from "../consumer/log/dto/StvLogLevel";

function info(message: string) {
    BackendService.postLogData(StvLogLevel.INFO, message);
}

function error(message: string, newEx?: any) {
    BackendService.postLogData(StvLogLevel.ERROR, message, newEx);
}

function warn(message: string) {
    BackendService.postLogData(StvLogLevel.WARN, message);
}

const AppLogger = {
    info,
    error,
    warn
}

export default AppLogger;

